export const css = {
    root: '_2IjykYbk',
    ' _key': 'afcpe-theme/dojo/grid-footer'
};
export default css;
